import { createApi } from 'modules/api'

import { alertManualApi as alertManual } from './methods/alertManual'
import { authApi as auth } from './methods/auth'
import { cfrDefaultParamsApi as cfrDefaultParams } from './methods/cfrDefaultParams'
import { cfrGroupsApi as cfrGroups } from './methods/cfrGroups'
import { cfrLogsApi as cfrLogs } from './methods/cfrLogs'
import { cognitiveSettingsApi as cognitiveSettings } from './methods/cognitiveSettings'
import { configApi as config } from './methods/config'
import { dataSourceFieldsApi as dataSourceFields } from './methods/dataSourceFields'
import { granularitiesApi as granularities } from './methods/granularities'
import { groupsApi as groups } from './methods/groups'
import { languagesApi as languages } from './methods/languages'
import { manualsApi as manuals } from './methods/manuals'
import { mlSettingsApi as mlSettings } from './methods/mlSettings'
import { projectMlApi as projectMl } from './methods/projectMl'
import { projectsApi as projects } from './methods/projects'
import { promoGroupsApi as promoGroups } from './methods/promoGroups'
import { promoLogsApi as promoLogs } from './methods/promoLogs'
import { promoOptimizerSettingsApi as promoOptimizerSettings } from './methods/promoOptimizerSettings'
import { promoPeriodsApi as promoPeriods } from './methods/promoPeriods'
import { promoSettingsApi as promoSettings } from './methods/promoSettings'
import { pythonTypesApi as pythonTypes } from './methods/pythonTypes'
import { rtmGroupsApi as rtmGroups } from './methods/rtmGroups'
import { rtmParametersApi as rtmParameters } from './methods/rtmParameters'
import { templatesApi as templates } from './methods/templates'
import { tetrisDefaultPricesApi as tetrisDefaultPrices } from './methods/tetrisDefaultPrices'
import { tetrisGroupsApi as tetrisGroups } from './methods/tetrisGroups'
import { tetrisLogsApi as tetrisLogs } from './methods/tetrisLogs'
import { usersApi as users } from './methods/users'

export const api = createApi({
  auth,
  dataSourceFields,
  users,
  groups,
  projects,
  projectMl,
  granularities,
  templates,
  promoGroups,
  promoLogs,
  promoOptimizerSettings,
  promoPeriods,
  promoSettings,
  pythonTypes,
  languages,
  mlSettings,
  cognitiveSettings,
  rtmGroups,
  rtmParameters,
  tetrisGroups,
  tetrisDefaultPrices,
  tetrisLogs,
  cfrGroups,
  cfrDefaultParams,
  config,
  cfrLogs,
  manuals,
  alertManual,
})
